import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { updateCanonical } from '../../actions/CanonicalActions';
import { propStr } from '../../helpers/custom-prop-types';
import { convertForCanonicalUrl } from '../../helpers/url';
const CanonicalComponent = (props) => {
    const { pathname } = props;
    const dispatch = useDispatch();
    const { url: canonicalUrl } = useSelector((state) => state.canonical);
    // pathname 変更時にURL更新
    useEffect(() => {
        const url = window.location.href;
        const convertedUrl = convertForCanonicalUrl(url);
        dispatch(updateCanonical(convertedUrl));
    }, [dispatch, pathname]);
    return (_jsx(Helmet, { children: _jsx("link", { href: canonicalUrl, rel: 'canonical' }) }));
};
CanonicalComponent.propTypes = {
    pathname: propStr().isRequired,
};
export default CanonicalComponent;
